<div class="workflow-example-item-container">
    <img src="{{domainSvc.currentDomain.id === 'job_examples_manufacturing' ? '/assets/pictos/workflows/' + workflow.id +'.jpg' : '/assets/pictos/workflows/' + workflow.id +'.svg'}}" alt={{workflow.title!}}>
    <p>{{workflow.title}}</p> 
</div>
